import { Shadows } from "@mui/material/styles";

/**
 * Professional's shadows are neutral, never warm: every tint here is
 * rgba(28, 38, 40, …). Playful's were rgba(120, 84, 40, …) — a brown lift that
 * reads as a smudge against a neutral page ground.
 *
 * Professional specifies three elevations, not twenty-four, so the ramp the app
 * inherited from its pre-MUI days is collapsed onto them:
 *
 *   index 1      chips, and anything else asking for the lightest lift
 *   index 2–7    cards and panels
 *   index 8–24   dialogs, menus and popovers
 *
 * The consumers inside `Override.tsx` land on the right tier by construction:
 * `MuiChip` uses `boxShadow: 1`, `MuiCard` uses `boxShadow: 2`, and the Dialog
 * paper imports `SHADOW_LG` directly.
 *
 * MUI requires exactly 25 entries.
 */

/** Lightest lift. Chips. */
const SHADOW_SM = "0 1px 4px rgba(28, 38, 40, 0.10)";
/** Cards and panels. */
const SHADOW_MD = "0 3px 10px rgba(28, 38, 40, 0.09)";
/** Floating surfaces: dialogs, menus, popovers. */
const SHADOW_LG = "0 14px 34px rgba(28, 38, 40, 0.18)";

const shadows: Shadows = [
  "none",
  SHADOW_SM,
  SHADOW_MD,
  ...(Array(5).fill(SHADOW_MD) as string[]),
  ...(Array(17).fill(SHADOW_LG) as string[]),
] as Shadows;

export default shadows;
export { SHADOW_SM, SHADOW_MD, SHADOW_LG };
